import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-man',
    templateUrl: './man.component.svg',
    styleUrls: ['./man.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManComponent {}
